import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { selectInsurance, selectLawFirm } from "../../../../lib/fetchApi"
import FalseInputSearch from "./FalseInputSearch"
import OutsideClickComponent from "../../../fragments/OutsideClickComponent"
import GroupItemSearchOption from "./GroupItemSearchOption"
import { caseActions } from "../../../../store/case"
import { isCaseArchived, useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"

import classes from './GroupItemSearch.module.css'
import LegacyData from "./LegacyData"

const GroupItemSearch = ({label, activeCaseData, data, fieldsData, folder, apiCase}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled(apiCase)

    const dispatch = useDispatch()


    const activeCase = useSelector(state => state.case.activeCase)
    const userToken = useSelector(state => state.user.token)
   
    const [groupDataState, setGroupDataState] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [openDrawer, setOpenDrawer] = useState(false)
    
    const clearAndClose = () => {
        setOpenDrawer(false)
        setGroupDataState(null)
    }

    const clickHandler = async () => {
        if (isCaseArchived(activeCase?.case?.master_status_id) || userPermissionDisabled) return
        // Toggle: clicking the same input while the drawer is open should close it.
        if (openDrawer) {
            clearAndClose()
            return
        }
        setIsLoading(true)
        setOpenDrawer(true)
        try {
        if (folder == 'attorneys') {
            if (data && data.all_reps) { // if there is all_reps here, don't make the api call again...
                if (data.all_reps[fieldsData.group] && data.all_reps[fieldsData.group].length > 0) {
                    setGroupDataState(data.all_reps[fieldsData.group])
                }
            } else {
                const groupData = await selectLawFirm(userToken, data.law_firm_id)
                if (groupData) {
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: data.id,
                        folder: folder,
                        content: groupData
                    }))
                    if (groupData[fieldsData.group] && groupData[fieldsData.group].length > 0) {
                        setGroupDataState(groupData[fieldsData.group])
                    }
                }
            }
        } else if (folder == 'liabilities') {
            if (data && data.all_reps) { // if there is all_reps here, don't make the api call again...
                if (data.all_reps[fieldsData.group] && data.all_reps[fieldsData.group].length > 0) {
                    setGroupDataState(data.all_reps[fieldsData.group])
                }
            } else {
                const groupData = await selectInsurance(userToken, data.insurance_carrier_id)
                if (groupData) {
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: data.id,
                        folder: folder,
                        content: groupData
                    }))
                    if (groupData[fieldsData.group] && groupData[fieldsData.group].length > 0) {
                        setGroupDataState(groupData[fieldsData.group])
                    }
                }
            }
        } else if (folder == 'mp_pip_um') {
            if (data && data.all_reps) { // if there is all_reps here, don't make the api call again...
                if (fieldsData.group == 'mp_adjuster' || fieldsData.group == 'um_adjuster') {
                    if (data.all_reps.adjusters && data.all_reps.adjusters.length > 0) {
                        setGroupDataState(data.all_reps.adjusters)
                    }
                } else {
                    if (data.all_reps[fieldsData.group] && data.all_reps[fieldsData.group].length > 0) {
                        setGroupDataState(data.all_reps[fieldsData.group])
                    }
                }
            } else {
                const groupData = await selectInsurance(userToken, data.insurance_carrier_id)
                if (groupData) {
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: data.id,
                        folder: folder,
                        content: groupData
                    }))
                    if (fieldsData.group == 'mp_adjuster' || fieldsData.group == 'um_adjuster') {
                        if (groupData.adjusters && groupData.adjusters.length > 0) {
                            setGroupDataState(groupData.adjusters)
                        }
                    } else {
                        if (groupData[fieldsData.group] && groupData[fieldsData.group].length > 0) {
                            setGroupDataState(groupData[fieldsData.group])
                        }
                    }
                }
            }
        } else if (folder == 'major_meds') {
            if (data && data.all_reps) { // if there is all_reps here, don't make the api call again...
                if (data.all_reps[fieldsData.group] && data.all_reps[fieldsData.group].length > 0) {
                    setGroupDataState(data.all_reps[fieldsData.group])
                }
            } else {
                const groupData = await selectInsurance(userToken, data.insurance_carrier_id)
                if (groupData) {
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: data.id,
                        folder: folder,
                        content: groupData
                    }))
                    if (groupData[fieldsData.group] && groupData[fieldsData.group].length > 0) {
                        setGroupDataState(groupData[fieldsData.group])
                    }
                }
            }
        } else if (folder == 'worker_comps') {
            if (data && data.all_reps) { // if there is all_reps here, don't make the api call again...
                if (data.all_reps[fieldsData.group] && data.all_reps[fieldsData.group].length > 0) {
                    setGroupDataState(data.all_reps[fieldsData.group])
                }
            } else {
                const groupData = await selectInsurance(userToken, data.insurance_carrier_id)
                if (groupData) {
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: data.id,
                        folder: folder,
                        content: groupData
                    }))
                    if (groupData[fieldsData.group] && groupData[fieldsData.group].length > 0) {
                        setGroupDataState(groupData[fieldsData.group])
                    }
                }
            }
        } else if (folder == 'worker_comp') {
            if (data && data.all_reps) { // if there is all_reps here, don't make the api call again...
                if (data.all_reps[fieldsData.group] && data.all_reps[fieldsData.group].length > 0) {
                    setGroupDataState(data.all_reps[fieldsData.group])
                }
            } else {
                const groupData = await selectInsurance(userToken, data.insurance_carrier_id)
                if (groupData) {
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: data.id,
                        folder: folder,
                        content: groupData
                    }))
                    if (groupData[fieldsData.group] && groupData[fieldsData.group].length > 0) {
                        setGroupDataState(groupData[fieldsData.group])
                    }
                }
            }
        }
        } finally {
            setIsLoading(false)
        }
    }


    let locAddress

    if (activeCaseData?.contact_information?.address_1 || activeCaseData?.contact_information?.city || activeCaseData?.contact_information?.state || activeCaseData?.contact_information?.zip) {

        locAddress = activeCaseData?.contact_information ? 
            activeCaseData.contact_information.address_1
            + ' ' + activeCaseData.contact_information.city 
            + ' ' + activeCaseData?.contact_information?.state 
            + ' ' + activeCaseData?.contact_information?.zip  
        : 
        ''
    } else {
        locAddress = activeCaseData?.name
    }

    return <div className={classes.container}>
        <OutsideClickComponent task={clearAndClose}>
            {activeCaseData && <>
                {/* {label == 'location' && <FalseInputSearch label={fieldsData.inputLabel} value={activeCaseData.name} minWidth={250} action={clickHandler} isLoading={isLoading}/>} */}
                {label == 'location' && <FalseInputSearch label={fieldsData.inputLabel} value={locAddress} minWidth={250} action={clickHandler} isLoading={isLoading}/>}
                {label !== 'location' && <FalseInputSearch label={fieldsData.inputLabel} value={`${activeCaseData?.first_name || ''} ${activeCaseData?.last_name || ''}`.trim()} minWidth={250} action={clickHandler} isLoading={isLoading}/>}
            </>}
            {/* {!activeCaseData && <FalseInputSearch label={fieldsData.inputLabel} value={null} minWidth={250} action={clickHandler} isLoading={isLoading}/>} */}

            {!activeCaseData && <>

                <LegacyData data={data} label={label} folder={folder} fieldsData={fieldsData} clickHandler={clickHandler} isLoading={isLoading}/>        

            </>}

            {openDrawer && (
                <div className={`${classes.searched_options} search_options_global`}>
                    {isLoading && <div className={`${classes.searched_option_empty} ${classes.searched_option_loader}`}><span className="loader dark"></span></div>}

                    {/* .filter(item => item.active) */}
                    {groupDataState && !isLoading && groupDataState.filter(item => (!Object.hasOwn(item, "active") || (item.active != null && item.active))).map(item => (
                        <GroupItemSearchOption key={item.id} item={item} data={data} fieldsData={fieldsData} action={clearAndClose} label={label} folder={folder}/>
                    ))}
                    {!groupDataState && !isLoading && <div className={classes.searched_option_empty}><i className="ti ti-exclamation-circle"></i>No items found!</div>}
                </div>
            )}
        </OutsideClickComponent>
    </div>
}

export default GroupItemSearch